import React from 'react';
import styled from 'styled-components';

const BattlesTabsScreen = ({ battlesAssets, rank, progress = null, points }) => {
  return (
    <Container>
      <Grid>
        <RankIcon src={battlesAssets.BATTLES_ICON} />
        <RankText data-text={rank}>
          <span>{rank}</span>
        </RankText>
      </Grid>
      <Grid disabled={progress === null}>
        <InfoText>{`${progress}%`}</InfoText>
      </Grid>
      <Grid>
        <PointsIcon src={battlesAssets.BATTLES_POINTS_ICON_BATTLES} />
        <InfoText>{points}</InfoText>
      </Grid>
    </Container>
  );
};

export default BattlesTabsScreen;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

const Grid = styled.div.withConfig({
  shouldForwardProp: prop => !['disabled'].includes(prop),
})`
  display: ${({ disabled }) => (disabled ? 'none' : 'flex')};
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

const RankIcon = styled.img`
  position: absolute;
  display: flex;
  width: 80%;
  height: 80%;
  justify-content: center;
  align-items: center;
  object-fit: contain;
  z-index: -1;
`;

export const RankText = styled.h1.withConfig({
  shouldForwardProp: prop => !['size'].includes(prop),
})`
  position: relative;
  display: inline;
  font-weight: 900;
  font-size: ${({ size }) => size || '4vw'};
  letter-spacing: -1.5px;
  margin-bottom: 0;

  span {
    position: relative;
    background: linear-gradient(0deg, #e7c377 0%, #e7c377 35%, #a1743d 50%, #fef7b9 51%, #e7c377 75%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    -webkit-text-stroke: 1px #ffff8d;
    filter: saturate(160%);
  }

  &::before {
    content: attr(data-text);
    position: absolute;
    top: 3px;
    left: -1.3px;
    z-index: -1;
    -webkit-text-stroke: 4px #400805;
    opacity: 1;
    ${({ theme }) => theme.BattlesTabsScreen.RankText}
  }

  &::after {
    content: attr(data-text);
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    color: rgba(0, 0, 0, 1);
    text-shadow: 5px 10px 15px rgba(0, 0, 0, 1);
    -webkit-text-stroke: 1.5px #ffff8d;
  }

  &::after {
    color: transparent;
  }

  ${({ theme }) => theme.screens.device('mobile-browser') && 'font-size: 3vw;'}
`;

const PointsIcon = styled.img`
  display: flex;
  width: 50%;
  height: 65%;
  justify-content: center;
  align-items: center;
  object-fit: contain;
  margin-top: 0.25rem;
`;

const InfoText = styled.span`
  color: #ffffff;
  font-size: 4vw;
  text-align: center;
  font-weight: 800;
  letter-spacing: -1.5px;
  text-transform: uppercase;

  ${({ theme }) => theme.BattlesTabsScreen.InfoText}
  ${({ theme }) => theme.screens.device('mobile-browser') && 'font-size: 3vw;'}
`;

